import React, { useEffect } from "react"
import { useState } from "react"
import TestCaseWidget from "./TestCaseWidget"

export default ({ resource, successCallback, errorCallback }) => {
    const [status, setStatus] = useState("testing")
    const [error, setError] = useState(null)

    // useEffect(() => {
    //     const testSocket = new WebSocket(`wss://${resource}/prod`)

    //     testSocket.onopen = event => {
    //         // testSocket.send(testData)
    //         successCallback()
    //         setStatus("pass")
    //     }

    //     testSocket.onerror = err => {
    //         setStatus("fail")
    //         errorCallback()
    //         setError(error)
    //     }

    //     return () => {
    //         try {
    //             testSocket.close()
    //         } catch (e) {}
    //     }
    // }, [])

    return <TestCaseWidget resource={resource} status={status} err={error} />
}



// WEBPACK FOOTER //
// ./src/websocketTest.js